import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'sonner';

/**
 * StripeReturn - Handles return from Stripe Connect onboarding
 * Redirects to /host/payouts with appropriate status
 */
const StripeReturn = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Show success message
    toast.success('Payout setup completed! Refreshing status...');
    
    // Redirect to host payouts with connected flag
    navigate('/host/payouts?connected=true', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Completing payout setup...</p>
      </div>
    </div>
  );
};

export default StripeReturn;
